module.exports = __webpack_public_path__ + "static/media/sparksLogo.49bd8e0c.png";